import { LorenTourStep } from "../interfaces/loren-tour-step.interface";
import { LOREN_ROUTES } from "./loren-routes.constants";
import { LorenFeature } from "../enums/loren-feature.enum";

export const LorenSidenavTourSteps: LorenTourStep[] = [
  {
    anchorId: "dashboard",
    content: "tour.home_screen_desc",
    title: "tour.home_screen_title",
    enableBackdrop: false,
  },
  {
    anchorId: "locations",
    content: "tour.locations_desc",
    title: "tour.locations_title",
    enableBackdrop: false,
  },
  {
    anchorId: "traces",
    content: "tour.traces_desc",
    title: "tour.traces_title",
    enableBackdrop: false,
    featureName: LorenFeature.GENERIC_TRACES,
  },
  {
    anchorId: "assets-list",
    content: "tour.assets_list_desc",
    title: "tour.assets_list_title",
    enableBackdrop: false,
  },
  {
    anchorId: "reports",
    content: "tour.reports_desc",
    title: "tour.reports_title",
    enableBackdrop: false,
  },
  {
    anchorId: "user-profile",
    content: "tour.user_profile_desc",
    title: "tour.user_profile_title",
    enableBackdrop: false,
    hideMobileNav: true,
  },
  {
    anchorId: "notifications",
    content: "tour.notifications_desc",
    title: "tour.notifications_title",
    enableBackdrop: false,
    hideMobileNav: true,
    isOptional: true,
  },
  {
    anchorId: "settings",
    content: "tour.settings_desc",
    title: "tour.settings_title",
    enableBackdrop: false,
  },

  {
    anchorId: "help",
    content: "tour.help_desc",
    title: "tour.help_title",
    enableBackdrop: false,
    isOptional: true,
  },
  {
    anchorId: "language",
    content: "tour.language_desc",
    title: "tour.language_title",
    enableBackdrop: false,
    isOptional: true,
  },
];

export const LorenSettingsTourSteps: LorenTourStep[] = [
  {
    anchorId: "geofencing",
    content: "tour.geofencing_desc",
    title: "tour.geofencing_title",
    enableBackdrop: false,
    featureName: LorenFeature.GENERIC_MAP_GEOZONES,
  },
  {
    anchorId: "automation-plans",
    content: "tour.automation_plans_desc",
    title: "tour.automation_plans_title",
    enableBackdrop: false,
    featureName: LorenFeature.GENERIC_RULES,
  },
  {
    anchorId: "groups",
    content: "tour.groups_desc",
    title: "tour.groups_title",
    enableBackdrop: false,
  },
];

export const LorenAutomationPlanTourSteps: LorenTourStep[] = [
  {
    anchorId: "ap.all_plans_container",
    content: "tour.ap_all_screen_content",
    title: "tour.ap_all_screen_title",
    route: LOREN_ROUTES.PLANS,
    enableBackdrop: false,
  },
  {
    anchorId: "ap.create_plan_create",
    content: "tour.create_plan_create_content",
    title: "tour.create_plan_create_title",
    enableBackdrop: false,
  },
  {
    anchorId: "ap.create_plan_name",
    content: "tour.create_plan_name_content",
    title: "tour.create_plan_name_title",
    route: LOREN_ROUTES.PLANS_.define(),
    enableBackdrop: false,
  },
  {
    anchorId: "ap.create_plan_period",
    content: "tour.create_plan_period_content",
    title: "tour.create_plan_period_title",
    enableBackdrop: false,
  },
  {
    anchorId: "ap.create_plan_delay",
    content: "tour.create_plan_delay_content",
    title: "tour.create_plan_delay_title",
    enableBackdrop: false,
  },
  {
    anchorId: "ap.create_plan_conditions",
    content: "tour.create_plan_conditions_content",
    title: "tour.create_plan_conditions_title",
    enableBackdrop: false,
  },
  {
    anchorId: "ap.create_plan_actions",
    content: "tour.create_plan_actions_content",
    title: "tour.create_plan_actions_title",
    enableBackdrop: false,
  },
];
